// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner__Loader__-hash64-5-"};